import { isSoftwareVersionSupported } from 'src/Libs/home-power-station/utils/is-software-version-supported'

const CABLE_LOCK_SOFTWARE_SUPPORT_PART_ONE = '2025'
const CABLE_LOCK_SOFTWARE_SUPPORT_PART_TWO = '06'
const LED_INTENSITY_SOFTWARE_SUPPORT_PART_ONE = '2025'
const LED_INTENSITY_SOFTWARE_SUPPORT_PART_TWO = '06'

export const supportsCableLockForWallbox = (softwareVersion?: string): boolean => {
  if (!softwareVersion) return false
  return isSoftwareVersionSupported(`${CABLE_LOCK_SOFTWARE_SUPPORT_PART_ONE}.${CABLE_LOCK_SOFTWARE_SUPPORT_PART_TWO}`, softwareVersion)
}

export const supportsLedIntensityForWallbox = (softwareVersion?: string): boolean => {
  if (!softwareVersion) return false
  return isSoftwareVersionSupported(`${LED_INTENSITY_SOFTWARE_SUPPORT_PART_ONE}.${LED_INTENSITY_SOFTWARE_SUPPORT_PART_TWO}`, softwareVersion)
}
